import { useEffect, useState } from "react";
import ModalCard from "../Components/ModalCard";
import "../styles/HomePage.css";
import { Link } from "react-router-dom";
export default function HomePage() {
  function Card({ url, label, description }) {
    return (
      <li className="card">
        <div className="card-img">
          {url ? (
            <img src={url} alt={label} />
          ) : (
            <img
              src={
                "https://pub-a3772f2b02704b91829728f4cc7bbe15.r2.dev/logo(new).svg"
              }
              alt={label}
            />
          )}
        </div>
        <h3 className="gc-text">{label}</h3>
        <p className="card-desc">{description}</p>
      </li>
    );
  }

  function SkillCard({ url, label, description }) {
    function OpenModal() {
      const modal = document.getElementById("modal");
      modal.classList.toggle("active", true);
      const longerdescription =
        skills.find((skill) => skill.label === label)?.longerdescription || "";
      setModalContent({ title: label, content: <>{longerdescription}</> });
    }
    return (
      <li className="card" onClick={OpenModal}>
        <div className="card-img">
          {url ? (
            <img src={url} alt={label} />
          ) : (
            <img
              src={
                "https://pub-a3772f2b02704b91829728f4cc7bbe15.r2.dev/logo(new).svg"
              }
              alt={label}
            />
          )}
        </div>
        <h3 className="gc-text">{label}</h3>
        <p className="card-desc">{description}</p>
      </li>
    );
  }
  const [modalContent, setModalContent] = useState({ title: "", content: "" });

  const skills = [
    {
      label: "Web development",
      description: "Modern, fast, scalable apps",
      longerdescription: (
        <>
          <p>
            Modern, fast, scalable websites and applications tailored to your
            business.
          </p>
          <p>
            I build custom solutions instead of forcing you into templates or
            bloated frameworks.
          </p>
          <p>
            Whether you need a business website, dashboard, or a full product,
            you’ll get something optimized, scalable, and easy to maintain.
          </p>
          <h3>What you get:</h3>
          <ul>
            <li>Custom frontend design (no copy-paste templates)</li>
            <li>Clean, modular code</li>
            <li>API Development</li>
            <li>CMS options</li>
            <li>Hosting and deployment</li>
            <li>Performance optimization</li>
          </ul>
        </>
      ),
    },
    {
      label: "Automation and Integration",
      description: "Reduce manual work, connect systems.",
      longerdescription: (
        <>
          <p>Save time, reduce manual work, and connect your systems.</p>
          <p>
            If your business is stuck doing things manually, I can automate it.
          </p>
          <p>If your tools don’t talk to each other, I make them talk.</p>
          <h3>Examples:</h3>
          <ul>
            <li>Automating data entry or reporting</li>
            <li>Connecting apps to WhatsApp, Airtime, Google Sheets, etc.</li>
            <li>Building custom admin tools</li>
            <li>Integrating payment gateways</li>
            <li>Email/SMS workflows</li>
            <li>Inventory automation</li>
          </ul>
        </>
      ),
    },
    {
      label: "Mobile apps",
      description: " Android, cross-platform, clean UI",
      longerdescription: (
        <>
          <p>Cross-platform apps with smooth UI and fast performance.</p>
          <p>
            From simple tools to full mobile products — I build apps that look
            modern, run fast, and don’t drain the battery.
          </p>
          <h3>Platforms:</h3>
          <ul>
            <li>iOS and Android support</li>
          </ul>
        </>
      ),
    },
    {
      label: "Consulting",
      description: " Architecture, system planning, product strategy.",
      longerdescription: (
        <>
          <p>When you’re not sure what to build — or how.</p>
          <p>
            Sometimes you need a developer to map things out before spending
            money.
          </p>
          <p>
            I help you break an idea into a real plan: features, timelines, cost
            estimates, and architecture.
          </p>
          <h3>Useful for:</h3>
          <ul>
            <li>Startups preparing MVPs</li>
            <li>Businesses digitizing their processes</li>
            <li>Teams needing technical direction</li>
            <li>Entrepreneurs with ideas but no tech background</li>
          </ul>
        </>
      ),
    },
    {
      label: "AI-Powered Solutions",
      description: "Email automation, task automation, operational tools.",
    },
  ];
  useEffect(() => {
    document.title = "amantes30 | Home";
    const navIcons = document.querySelectorAll(".icon-wrapper");
    navIcons.forEach((icon) => {
      icon.classList.remove("active");
    });
    const selectedIcon = document.getElementById("Home-icon");
    if (selectedIcon) {
      selectedIcon.classList.add("active");
    }
  }, []);
  return (
    <>
      <section className="hero">
        <h1 className="hero-text">from idea to launch</h1>
        <p className="hero-desc">
          I'm Aman, the developer behind <b>amantes30</b>. I craft web
          experiences that load fast, scale sensibly, and don’t explode on
          maintenance day. If you want pragmatic architecture, honest timelines,
          and clean UI, we should talk.
        </p>
        <Link to="/contact" className="p-btn">
          Get a quote
        </Link>
      </section>
      <section className="features">
        <h2 className="gc-text">What do I do?</h2>
        <ul className="list-of-skills">
          {skills.map((skill) => (
            <SkillCard
              key={skill.label}
              url={`./images/${skills.indexOf(skill) + 1}.png`}
              label={skill.label}
              description={skill.description}
            />
          ))}
          <ModalCard
            title={modalContent.title}
            content={modalContent.content}
          />
        </ul>
      </section>
      <section className="testimonials">
        <h2 className="gc-text">How I work</h2>
        <ul className="list-of-skills">
          <Card
            url={"./images/5.png"}
            label={"01/ Discover"}
            description={"Quick call → requirements → scope"}
          />
          <Card
            url={"./images/6.png"}
            label={"02/ Plan"}
            description={"Wireframes, timeline, cost breakdow"}
          />
          <Card
            url={"./images/7.png"}
            label={"03/ Build"}
            description={"Iterative development with weekly demos"}
          />
          <Card
            url={"./images/8.png"}
            label={"04/ Deliver"}
            description={" Deployment, optimization, documentation"}
          />
          <Card
            url={"./images/4.png"}
            label={"05/ Support"}
            description={"After-delivery care + future improvements"}
          />
        </ul>
      </section>

      <section className="our-work">
        <h2 className="gc-text">Our work</h2>
        <ul className="list-of-skills">
          <Card
            url={"./images/ema-logo.webp"}
            label={"EMA"}
            description={
              "Lightweight inventory management web app built to solve a problem I faced personally while running a small shop with friends."
            }
          />
          <Card
            url={"./images/11.png"}
            label={"AI-Powered Customer Support"}
            description={
              "AI-powered customer support system designed to automate responses to common queries, reduce response times, and free up human resources for more complex tasks."
            }
          />
          <Card
            url={"./images/7.png"}
            label={"QRWaiter "}
            description={
              "Restaurant ordering platform that allows customers to scan a QR code at their table, browse the menu, and place orders directly from their device."
            }
          />
          <Card
            url={"./images/12.png"}
            label={"Automated email marketing"}
            description={
              "Automated email marketing system built to help small businesses send targeted, timely messages to their customers without manual effort"
            }
          />
        </ul>
      </section>
      {/* <section className="">
                <h2 className="gc-text">Key Stats</h2>
            </section> */}
    </>
  );
}
